// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"b6490217","76":"235ec7f7","103":"0362ffb8","133":"b4c57d7a","157":"a6f4d9f2","786":"5f5cc8e1","787":"7c188a15","868":"25bc9952","908":"8b3b9a79"}[chunkId] + ".chunk.js";
};